import styled from 'styled-components';

interface ModalContentStyleProps {
  maxWidth?: number;
}

export const ModalContent = styled.div<ModalContentStyleProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : '80%')};
  max-height: 80%;
  overflow: auto;
  background-color: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border: 1px solid #dae2ed;
  outline: none;

  > header {
    padding: 24px;
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);

    & .modal-title {
      font-size: 24px;
      font-weight: 600;
      text-align: start;
      margin: 0;
      line-height: 1.5rem;
      color: #1c2025;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      color: #303740;
      margin-bottom: 4px;
    }
  }

  > div {
    padding: 0 24px 24px;
  }
`;
